/*  Private Device Vault — schemas & compartment IDs.
    Not TypeScript, but the shapes below document what each compartment stores.
    Everything here is pure data — no side effects, safe to import anywhere.  */

export const COMPARTMENT = {
  HEALTH:    "health_emergency",
  INVENTORY: "household_inventory",
};

export const BLOOD_TYPES = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-", "Unknown"];

export const INVENTORY_CATEGORIES = [
  "Jewelry & Watches", "Electronics & Computers", "Cameras", "Appliances",
  "Furniture", "Art & Collectibles", "Tools & Equipment", "Musical Instruments",
  "Bicycles & Sports Equipment", "Vehicles", "Important Travel Equipment", "Other Valuables",
];

export const INVENTORY_STATUSES = ["active", "sold", "donated", "lost", "damaged", "disposed"];

export const ATTACHMENT_TYPES = ["photo", "receipt", "warranty", "appraisal", "invoice"];

/** New empty health compartment shape — used on first-time onboarding. */
export function emptyHealthCompartment() {
  return {
    personalInfo: {
      fullName: "", dateOfBirth: "", bloodType: "Unknown",
      organDonor: false, primaryLanguage: "",
    },
    emergencyContacts: [],
    allergies: [],
    medicalConditions: [],
    medications: [],
    providers: [],
    insurance: { providerName: "", policyNumber: "", groupNumber: "", phone: "", notes: "" },
    vaccinations: [],
    medicalDevices: [],
    accessibilityRequirements: [],
    emergencyInstructions: "",
    userVitalsLog: [],
  };
}

/** New empty inventory compartment. */
export function emptyInventoryCompartment() {
  return {
    items: [],
    rooms: ["Living Room", "Kitchen", "Primary Bedroom", "Home Office", "Garage"],
    owners: [],
  };
}

/** Factory helpers — small, dumb, easy to reason about. */
export function newEmergencyContact() {
  return { id: crypto.randomUUID(), name: "", relationship: "", phone: "",
           alternatePhone: "", email: "", isPrimary: false };
}

export function newMedication() {
  return { id: crypto.randomUUID(), name: "", dosage: "", frequency: "",
           purpose: "", prescribingDoctorId: null, notes: "", isActive: true,
           status: "active", statusReason: "", startDate: "", endDate: "" };
}

export function newProvider() {
  return { id: crypto.randomUUID(), name: "", specialty: "", phone: "",
           clinicName: "", address: "" };
}

export function newVaccination() {
  return { id: crypto.randomUUID(), vaccineName: "", dateAdministered: "",
           expirationDate: "", lotNumber: "", administeredBy: "", isTravelRequired: false };
}

export function newInventoryItem() {
  return {
    id: crypto.randomUUID(),
    name: "", category: "Other Valuables", description: "",
    brand: "", model: "", serialNumber: "",
    purchaseDate: "", purchasePrice: null, currency: "USD",
    estimatedReplacementValue: 0, storeVendor: "", warrantyExpiration: "",
    locationInHome: "", owner: "",
    attachments: [], insurancePolicyReference: "", notes: "",
    status: "active", lastVerifiedDate: new Date().toISOString(),
  };
}

export function newAttachment(type, filename, mimeType, blobKey, fileSize) {
  return {
    id: crypto.randomUUID(),
    type, filename, mimeType, localBlobKey: blobKey, fileSize,
    uploadedAt: new Date().toISOString(),
  };
}
